import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router/index.js'

import UserStoreModule from '@/store/user'
import VuexPersistence from 'vuex-persist'
import SecureLS from 'secure-ls'

const ls = new SecureLS({ isCompression: false, encodingType: 'aes' })

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    modules: ['userModule'],
    key: 'vxp',
    saveState: (key, state) => ls.set(key, state),
    restoreState: (key) => ls.get(key),
})

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [vuexLocal.plugin],
    modules: {
        userModule: UserStoreModule,
    },
    state: {
        snackbarErrorMessage: '',
        snackbarSuccessMessage: '',
        snackbarWarningMessage: '',
        snackbarInfoMessage: '',
        showLoader: false,
        loaderCount: 0,
        user: null,
        selectedSecretary: null,
        selectedFund: null,
        selectedInstitution: null,
        selectedCouncil: null,
        selectedUser: null,
        selectedAgent: null,
        councilImage: '/images/logo-benfeitores.svg',
        councilBackgroundImage: '/images/logo_main.svg',
        councilId: null,
        paymentMethod: null
    },
    mutations: {
        SET_SELECTED_SECRETARY: function(state, secretary) {
            state.selectedSecretary = secretary
        },
        SET_SELECTED_FUND: function(state, fund) {
            state.selectedFund = fund
        },
        SET_SELECTED_INSTITUTION: function(state, institution) {
            state.selectedInstitution = institution
        },
        SET_SELECTED_COUNCIL: function(state, council) {
            state.selectedCouncil = council
        },
        SET_SELECTED_USER: function(state, user) {
            state.selectedUser = user
        },
        SET_SELECTED_AGENT: function(state, agent){
            state.selectedAgent = agent;
        },
        SET_SNACKBAR_ERROR_MESSAGE: function(state, value) {
            state.snackbarErrorMessage = value
        },
        SET_SNACKBAR_SUCCESS_MESSAGE: function(state, value) {
            state.snackbarSuccessMessage = value
        },
        SET_SNACKBAR_WARNING_MESSAGE: function(state, value) {
            state.snackbarWarningMessage = value
        },
        SET_SNACKBAR_INFO_MESSAGE: function(state, value) {
            state.snackbarInfoMessage = value
        },
        SET_LOADER: function(state, value) {
            if (this.loaderCount == null || this.loaderCount === undefined)
                this.loaderCount = 0
            if (value) {
                this.loaderCount++
                if (this.loaderCount == 1) state.showLoader = true
            } else {
                this.loaderCount--
                if (this.loaderCount == 0) state.showLoader = false
            }
        },
        SET_COUNCIL_IMAGE: function(state, councilImage) {
            state.councilImage = councilImage
        },
        SET_COUNCIL_BACKGROUND_IMAGE: function(state, image) {
            state.councilBackgroundImage = image
        },
        SET_COUNCIL_ID(state, councilId) {
            state.councilId = councilId;
        },
        SET_PAYMENT_METHOD(state, payload) {
            state.paymentMethod = payload;
        }
    },
    actions: {
        setSelectedSecretary(context, secretary) {
            context.commit('SET_SELECTED_SECRETARY', secretary)
        },
        setSelectedFund(context, fund) {
            context.commit('SET_SELECTED_FUND', fund)
        },
        setSelectedInstitution(context, institution) {
            context.commit('SET_SELECTED_INSTITUTION', institution)
        },
        setSelectedCouncil(context, council) {
            context.commit('SET_SELECTED_COUNCIL', council)
        },
        setSelectedUser(context, user) {
            context.commit('SET_SELECTED_USER', user)
        },
        setSelectedAgent(context, agent) {
            context.commit('SET_SELECTED_AGENT', agent)
        },
        setCouncilImage(context, image) {
            context.commit('SET_COUNCIL_IMAGE', image)
        },
        setCouncilBackgroundImage(context, image) {
            context.commit('SET_COUNCIL_BACKGROUND_IMAGE', image)
        },
        setCouncilId(context, councilId) {
            context.commit('SET_COUNCIL_ID', councilId)
        },
        setPaymentMethod(context, payload) {
            context.commit('SET_PAYMENT_METHOD', payload)
        },
    },
    getters: {
        selectedSecretary: (state) => {
            return state.selectedSecretary
        },
        selectedFund: (state) => {
            return state.selectedFund
        },
        selectedInstitution: (state) => {
            return state.selectedInstitution
        },
        selectedCouncil: (state) => {
            return state.selectedCouncil
        },
        selectedUser: (state) => {
            return state.selectedUser
        },
        selectedAgent: (state) => {
            return state.selectedAgent
        },
        showLoader: (state) => {
            return state.showLoader
        },
        snackbarErrorMessage: (state) => {
            return state.snackbarErrorMessage
        },
        snackbarSuccessMessage: (state) => {
            return state.snackbarSuccessMessage
        },
        snackbarWarningMessage: (state) => {
            return state.snackbarWarningMessage
        },
        snackbarInfoMessage: (state) => {
            return state.snackbarInfoMessage
        },
        getCouncilImage: (state) => {
            return state.councilImage
        },
        getCouncilBackgroundImage: (state) => {
            return state.councilBackgroundImage
        },
        getCouncilId: (state) => {
            const route = router.app._route
            if(!route) {
                return state.councilId;
            }
            if (
                route.params &&
                route.params.councilId &&
                route.meta &&
                route.meta.isCouncilUrl
            )
                return route.params.councilId
            return null
        },
        getPaymentMethod: (state) => {
            return state.paymentMethod
        },
    },
})
